import { render, staticRenderFns } from "./FeedbackFull.vue?vue&type=template&id=77fb704e"
import script from "./FeedbackFull.vue?vue&type=script&lang=js"
export * from "./FeedbackFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports